import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface RibbonMenuItem {
	id: string;
	label: string;
	icon: string;
	badgeCount?: number;
}

@Component({
	selector: 'app-ribbon-menu',
	templateUrl: './ribbon-menu.component.html',
	styleUrls: ['./ribbon-menu.component.scss'],
})
export class RibbonMenuComponent {

	@Input() menuItems: RibbonMenuItem[] = [];
	@Input() activeItem: string | null = null;
	@Input() notesCount: number = 0;
	@Input() tasksCount: number = 0;

	@Output() itemClicked = new EventEmitter<string>();

	getBadgeCount(item: RibbonMenuItem): number | null {

		if (item.id === 'notes' && this.notesCount > 0) {
			return this.notesCount;
		}

		if (item.id === 'tasks' && this.tasksCount > 0) {
			return this.tasksCount;
		}

		return item.badgeCount || null;
	}

	onItemClick(itemId: string): void {
		this.itemClicked.emit(itemId);
	}

}
